import { useSyncExternalStore } from 'react';

// B-GPS1/2 · Đồng ý ghi vị trí + sự kiện vị trí nhóm hiện trường.
// Giả lập: cờ giữ trong bộ nhớ (chưa ghi DB); sự kiện phát qua window cho Ezy › Điều phối hiện trường nghe
// (không import chéo vùng). Khi A-GPS (`/v1/field/events`) có thì thay `emitFieldEvent` bằng gọi API.

export interface LocationConsent {
  agreed: boolean;
  /** ngày ký, dạng YYYY-MM-DD */
  signedOn: string | null;
  /** tên tệp văn bản đồng ý */
  file: string | null;
}

export const CONSENT_FILE = 'Dong-y-ghi-vi-tri.pdf';
export const FIELD_EVENT = 'hana:field-location';

export interface FieldLocationEvent {
  userId: string;
  kind: 'in' | 'out';
  lat: number;
  lng: number;
  /** sai số (mét) */
  accuracy: number;
  /** ISO 8601 */
  at: string;
}

let consent: LocationConsent = { agreed: false, signedOn: null, file: null };
const subs = new Set<() => void>();

export const getConsent = (): LocationConsent => consent;
export function setConsent(agreed: boolean, today: string): void {
  consent = agreed ? { agreed: true, signedOn: today, file: CONSENT_FILE } : { agreed: false, signedOn: null, file: null };
  subs.forEach((f) => f());
}
export function useLocationConsent(): LocationConsent {
  return useSyncExternalStore(
    (f) => (subs.add(f), () => void subs.delete(f)),
    getConsent,
    getConsent,
  );
}

/** Toạ độ mẫu của điểm hiện trường (KCN VSIP 1) — không gọi GPS thật. */
export const SAMPLE_FIX = { lat: 10.9446, lng: 106.7103, accuracy: 12 } as const;

/** Chưa đồng ý → null: app chỉ ghi ảnh, không ghi GPS. */
export function buildFieldEvent(c: LocationConsent, userId: string, kind: 'in' | 'out', at: string): FieldLocationEvent | null {
  if (!c.agreed) return null;
  return { userId, kind, ...SAMPLE_FIX, at };
}

export function emitFieldEvent(ev: FieldLocationEvent | null): boolean {
  if (!ev || typeof window === 'undefined') return false;
  window.dispatchEvent(new CustomEvent<FieldLocationEvent>(FIELD_EVENT, { detail: ev }));
  return true;
}
